import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'src/app/components/content-oauth/services/oauth.service';
import { ComponentUtilsService } from './component-utils.service';

@Injectable({
  providedIn: 'root',
})
export class MicrosoftService {
  constructor(
    protected httpClient: HttpClient,
    protected componentUtilsService: ComponentUtilsService,
    private authService: OAuthService,
  ) {}

  revoke(provider) {
    return this.authService
      .revoke(provider)
      .then((revoked: boolean) => revoked)
      .catch((err) => {
        console.error('Failed to revoke access for user.', err);

        throw err;
      });
  }
}
